<template lang="pug">
  .home-blog-section.container.ui-color-3-bg
    .row.title-section
      h2.core-title.text-color-2.f-secondary.xs-f-grande.lg-f-xgrande.max-at-tweak(v-html="sectionTitle")
      p.mb-20.xs-f-medium.description {{ description }}
    .row.carousel-wrapper(ref="carousel")
      .inner-carousel
        reactive-to-items-carousel(:items='posts', :slides-to-show='slidesToShow' :item-total-width="itemTotalWidth" :breakpoint-offset="breakpointOffset" :dots="false")
          template(#default="{ item, index }")
            blog-cards-carousel(:ref="`item-${index}`" :data-mr-carousel-id="`${index}`" :item='item')
</template>

<script>
  import ReactiveToItemsCarousel from '@components/Carousels/ReactiveToItemsCarousel';
  import BlogCardsCarousel from '@components/Carousels/BlogCardsCarousel';

  export default {
    name: "HomeBlogSection",

    components: {
      ReactiveToItemsCarousel,
      BlogCardsCarousel,
    },

    props: {
      sectionTitle: {
        type: String,
        default: 'Love is in the hair',
      },
      description: {
        type: String,
        default: 'A blog about hair color, confidence, and feeling beautiful.',
      },
      posts: {
        type: Array,
        required: true,
        default() {
          [];
        }
      },
      slidesToShow: {
        type: Number,
        required: true,
        default: 3
      },
      itemTotalWidth: {
        type: Number,
        default() {
          return 336;
        }
      },
      breakpointOffset: {
        type: Number,
        default() {
          return 48 * 2;
        },
      },
    },
  };
</script>

<style lang="stylus">
.home-blog-section
  min-height 670px
  padding 0 1em
  max-width 1300px
  margin 2em auto
  overflow hidden

  .title-section
    text-align center

    @media mq-tablet-less
      text-align left

    .core-title
      margin-top 0.5em

  .inner-carousel
    width 100%

    .reactive-to-items-carousel
      :deep(.cards-carousel)
        @media only screen and (max-width: 1104px)
          background-color ui-color-3
          padding 0em 1.5002884615341339em
          overflow hidden
          min-height 40.43634615372951em

  .slick-dots
    display none !important    
</style>
